import React, { Suspense } from 'react'
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import { CSpinner } from '@coreui/react-pro'

import GlobalVariablesContextWrapper from 'src/contexts/globalVariableContext'
import { AuthIsNotSignedIn, AuthIsSignedIn, AuthProvider } from 'src/contexts/authContext'
import DefaultLayout from './layout/DefaultLayout'
import Login from './layout/userLogin/Login'
import ForgotPassword from './layout/forgotPassword/ForgotPassword'
import ValidateForgotPassword from './layout/forgotPassword/ValidateForgotPassword'
import FirstTimeForcePassword from './layout/userLogin/FirstTimeForcePassword'
import NewPassword from './layout/forgotPassword/NewPassword'

import TenderView from './views/tender-view/TenderView'
import TenderOverview from './views/tender-overview/TenderOverview'
import IncomingAttachments from './views/incoming-attachments/IncomingAttachments'
import Amplify from 'aws-amplify'
import { HelmetProvider } from "react-helmet-async";

import './scss/style.scss'
import UnauthorizedHeadContent from './components/helmet/UnauthorizedHeadContent'
import AuthorizedHeadContent from './components/helmet/AuthorizedHeadContent'

const App = () => {
  Amplify.configure({
    Auth: {
      region: 'eu-central-1',
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolWebClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
      mandatorySignIn: false,
      authenticationFlowType: 'USER_PASSWORD_AUTH',
      oauth: {
        domain: `${process.env.REACT_APP_COGNITO_DOMAIN}.auth.eu-central-1.amazoncognito.com`,
        scope: ['openid'],
        redirectSignIn: `${process.env.REACT_APP_COGNITO_REDIRECT_URI}/tender-overview`,
        redirectSignOut: `${process.env.REACT_APP_COGNITO_REDIRECT_URI}`,
        responseType: 'token',
      },
    },
  })

  return (
    <GlobalVariablesContextWrapper>
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <Suspense
            fallback={
              <div className='pt-3 text-center'>
                <div className='spinner--wrapper'>
                  <CSpinner color='primary' variant='grow' />
                </div>
              </div>
            }
          >
            <AuthIsNotSignedIn>
              <UnauthorizedHeadContent />
              <Routes>
                <Route path='/' element={<Login />} />
                <Route path='/forgot-password' element={<ForgotPassword />} />
                <Route path='/validate-forgot-password' element={<ValidateForgotPassword />} />
                <Route path='/new-password' element={<NewPassword />} />
                <Route path='/force-new-password' element={<FirstTimeForcePassword />} />
                <Route path='/incoming-attachments/:incomingAttachmentId' element={<Navigate to='/' replace />} />

                <Route path='/tender-overview' name='Home' element={<Navigate to='/' replace />} />
                <Route
                  path='/tender-overview/tender-detail-view/:tenderId'
                  name='Home'
                  element={<Navigate to='/' replace />}
                />
              </Routes>
            </AuthIsNotSignedIn>
            <AuthIsSignedIn>
              <AuthorizedHeadContent />
              <Routes>
                <Route path='/incoming-attachments/:incomingAttachmentId' element={<IncomingAttachments />} />
                <Route path='/' name='Home' element={<Navigate to='/tender-overview' replace />} />
                <Route path='*' element={<DefaultLayout />}>
                  <Route path='tender-overview' element={<TenderOverview />} />
                  <Route
                    path='tender-overview/tender-detail-view/:tenderId'
                    element={<TenderView />}
                  />
                </Route>
              </Routes>
            </AuthIsSignedIn>
          </Suspense>
        </BrowserRouter>
      </AuthProvider>
      </HelmetProvider>
    </GlobalVariablesContextWrapper>
  )
}

export default App
